import translate from 'core/translate'
import styles from '../uploader.styles.jcss'
import EditText from 'blocks.simple/editText/editText'
import React from 'react'

const CsvDivider = ({
    showDivider,
    divider,
    setDivider,
}: {
    showDivider: boolean
    divider: string
    setDivider: (value: string) => void
}) => {
    if (!showDivider) return null
    return (
        <div className={styles.divider}>
            <div className={styles.dividerTitle}>{translate('separator')}</div>
            <EditText
                mod={'withBorder'}
                value={divider}
                indentSize={'normal'}
                placeholder={translate('enter')}
                className={styles.dividerInput}
                onChange={(value: string) => {
                    setDivider(value)
                }}
            />
        </div>
    )
}

export default CsvDivider
